<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
  
      <div class="row" v-if="userData.permissions['sell_medicine']==1">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
              <div class="col-md-4">
              <div class="card" style="box-shadow: 0 0 2px gray;">
                <div class="card-body">
                    <form @submit.prevent="AddtoCart">
                      <div class="form-group mb-2">
                        <label>Category</label>
                        <multiselect v-model="category" label="name" @input="FilterProducts" :options="productcategories"></multiselect>
                      </div>
                      <div class="form-group mb-2">
                        <label>Product</label>
                        <multiselect v-model="product" label="name" @input="FilterProductUnits" :options="products"></multiselect>
                      </div>

                      <div class="form-group mb-2">
                      <label>Unit</label>
                        <multiselect v-model="unit" label="unit" @input="FilterPrice" :options="units"></multiselect>
                      </div>
                      <i class="text-danger float-end">Base Quantity : {{ this.unit.base_quantity }}</i>
                      <div class="form-group mb-2">
                        <label>Price</label>
                        <input v-model="price" type="number" required class="form-control" />
                      </div>
                      <div class="form-group mb-2">
                        <label>Quantity</label>
                        <input v-model="quantity" type="number" required min="1" :max="(this.product.quantity/this.unit.base_quantity)" class="form-control" />
                      </div>
                      <i class="text-danger float-end">in stock : {{ this.product.quantity }}</i>
                      <div class="form-group">
                    <b-button class="btn w-100" type="submit" variant="primary"><i class="fas fa-check-circle"></i> Submit</b-button>
                    </div>
                    </form>
                </div>
              </div>
              </div>
              <div class="col-md-8">    
                <div class="card" style="box-shadow: 0 0 2px gray;">
                  <span v-if="this.salecarts.length<=0">
                    <div class="d-flex justify-content-center p-5">
                    <span class="mdi mdi-pill text-success display-5"></span><br>
                    <span class="h4 mt-4">No Item Selected</span>
                  </div>
                  </span>
                  <span v-else>
                    <div class="table-responsive">
                      <b-table
                        :items="Items"
                        :fields="Fields"
                        responsive="sm"
                        :busy="IsBusy"
                      >
                      <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                      <template #cell(index)="data">
                        {{ data.index + 1 }}
                      </template>
                      <template #cell(product)="data">
                        {{ data.item.product.name }}
                      </template>
                      <template #cell(category)="data">
                        {{ data.item.category.name }}
                      </template>
                      <template #cell(unit)="data">
                        {{ data.item.unit.unit_name }}
                      </template>
                      <template #cell(actions)="data">
                        <b-button @click="remove(data.item.id,data.item.product.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                      </template>
                      </b-table>
                    </div>
                    <div class="row mx-1">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Total</label>
                          <input v-model="cart_total" type="number" readonly class="form-control" />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Amount Paid</label>
                          <input v-model="amountpaid" :max="cart_total" type="number" required class="form-control" />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Payment Option</label>                        
                          <multiselect v-model="payoption" label="name" :options="paymentoptions"></multiselect>
                        </div>
                      </div>
                      <div class="col-md-4 mb-2">
                        <div class="form-group">
                          <label>Pay Date</label>
                          <input v-model="paydate" type="date" required class="form-control" />
                        </div>
                      </div>
                      <div class="col-md-4">
                          <b-button class="btn w-100 mt-4 mb-2" @click="SubmitExit" variant="primary"><i class="mdi mdi-check-circle"></i> SUBMIT & EXIT</b-button>
                      </div>
                      <div class="col-md-4">
                          <b-button class="btn w-100 mt-4 mb-2" @click="SubmitPrint" variant="success"><i class="mdi mdi-printer"></i> SUBMIT & PRINT</b-button>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to Sell Medicine</span></center>
          </div>
        </div>
      </div>
      </div>
      <b-modal id="delete-unit" centered title="Delete From Cart" title-class="font-18" hide-footer>
          <form @submit.prevent="removeFromCart">
              <input v-model="id" type="hidden">
                Are you sure you want to remove the Product : <b>{{ product }}</b> ?
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-unit')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
              </div>
          </form>
      </b-modal> 
  
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  import Multiselect from "vue-multiselect";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { 
    paymentoptionMethods, paymentoptionComputed,
    productcategoryMethods, productcategoryComputed,
    salecartMethods, salecartComputed
   } from "@/state/helpers";
  
  export default {
    page: {
      title: "Sell Medicine",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader,Multiselect
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("user")),
        title: "Sell Medicine",
        items: [ {text: "Dashboard",to: "/",}, {text: "Sell Medicine",active: true, }, ],
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'category', label: 'Category', visible: true },
            { key: 'product', label: 'Product Name', visible: true },
            { key: 'unit', label: 'Unit Name', visible: true },
            { key: 'price', label: 'Price', visible: true },
            { key: 'quantity', label: 'Quantity', visible: true },
            { key: 'actions', label: 'Remove', visible: true },
          ],
        products:[],
        units:[],
        id:'',
        category:'',
        product:'',
        instock:'0',
        unit:'',
        amountpaid:0,
        price:'',
        quantity:'1',
        description:'',
        paydate:new Date().toLocaleDateString('fr-CA'),
        payoption:'',
      };
    },
    computed: {
      ...salecartComputed,
      ...productcategoryComputed,
      ...paymentoptionComputed,
      cart_total(){ var total = 0; this.salecarts.forEach((item)=>{ var item_total = item.price*item.quantity; total = total+item_total;}); return total },
      List() { return this.salecarts.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.salecarts.map((d) => ({...d }))},
      Cart() { return this.salecarts.map((d) => ({id:d.id,unit:d.unit.id,product:d.product.id,quantity:d.quantity,price:d.price }))},
      IsBusy() { let a=false; if (this.salecarts.length>0) { a=false;} else { a=true;} return a },
    },
    mounted() {
      this.fetchPaymentoptions();
      this.fetchSalesCart();
      this.fetchCategories();
      this.isBusy=false;
      this.payoption = this.paymentoptions.find(option => option.set_default == 1);
    },
    methods: {
      ...salecartMethods,
      ...productcategoryMethods,
      ...paymentoptionMethods,
      commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
      remove(id,product){
        this.id=id;
        this.product=product;
        this.$bvModal.show('delete-unit')
      },
      async FilterProducts(){
        let url = `/productbycategory/${this.category.id}`;
        await axios.get(url).then((response) => {
          this.products = response.data.products;
        });
      },
      async FilterProductUnits(){
        let url = `/unitsbyproduct/${this.product.id}`;
        await axios.get(url).then((response) => {
          this.units = response.data.units;
          });
      },
      async FilterPrice(){
        let url = `/productbyunitprice/${this.unit.unit_id},${this.product.id}`;
        await axios.get(url).then((response) => {
          this.price = response.data.price;
          });
      },
      async AddtoCart() { 
        let formData = new FormData();
        formData.append("category", this.category.id);
        formData.append("product", this.product.id);
        formData.append("unit", this.unit.unit_id);
        formData.append("price", this.price);
        formData.append("quantity", this.quantity);
        let url = "/addtocart";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.payoption = this.paymentoptions.find(option => option.set_default == 1);
            this.fetchSalesCart();
            this.$bvModal.hide('new-unit');
            this.category="";
            this.product="";
            this.unit="";
            this.price="";
            this.quantity="";
        }
        });
      },
      async removeFromCart() { 
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/deletefromcart";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSalesCart();
          this.$bvModal.hide('delete-unit');
        }
      });
      },
      async SubmitExit(){
        let obj = {cart:this.Cart, amount:this.amountpaid, total:this.cart_total, payoption:this.payoption.id,paydate:this.paydate }
        let url = "/savecart";
        await axios.post(url, obj).then((response) => {
          if (response.status == 200) {
            this.fetchSalesCart();
            this.$toast.success("New Medicine Sale Added");
          }
        });
      },
      async SubmitPrint(){
        let obj = {cart:this.Cart, amount:this.amountpaid, total:this.cart_total, payoption:this.payoption.id,paydate:this.paydate }
        let url = "/savecart";
        await axios.post(url, obj).then((response) => {
          if (response.status == 200) {
            this.$router.push({ path: '/printreciept',  query: { id: response.data } })
            // this.$toast.success("New Medicine Sale Added");
          }
        });
      }
    },
  };
  </script>